import React from 'react'
import {
  Container,
  Logo,
  Content
} from './styles'
import { useTheme } from 'styled-components'

export const SpinnerLoader = (props) => {
  const {
    logotype,
    content,
    style,
    iconStyle
  } = props
  const theme = useTheme()
  return (
    <Container style={style}>
      {logotype && (
        <Logo>
          <img src={logotype} alt='logo' width='266px' height='150px' loading='lazy' />
        </Logo>
      )}
      {content && (
        <Content>
          {content}
        </Content>
      )}
        <div style={{ ...iconStyle }}>
          <img
            src={theme.images.logos.logotypeLoading}
            width="135px"
            height="100px"
          />
        </div>
    </Container>
  )
}
